
import { mapGetters } from "vuex"
import fields from '@/helpers/report-fields.js'

export default {
    data() {
        return {
            tempReport: null,
            store: []
        }
    },
    computed: {
        ...mapGetters([
            'report',
            'reportingData'
        ]),
        stateStoring: function () {
            const self = this
            return {
                enabled: true,
                savingTimeout: 100,
                type: "custom",
                customLoad: () => {
                    return {         
                        columnExpandedPaths: self.tempReport.columnExpandedPaths,
                        fields: self.tempReport.fields,
                        rowExpandedPaths: self.tempReport.rowExpandedPaths
                    }
                }
            }
        },
        dataSource: function () {
            return {
                fields,
                $temp: this.tempReport, // ugly workarround to update the datasource on mutation of tempReport. 
                store: this.tempReport.settings.decoupleFromSeasonSelection ? this.store : this.reportingData
            }
        }
    },
    watch: {
        report (val) {
            this.tempReport = Object.assign({}, JSON.parse(JSON.stringify(val)))
            if (this.tempReport.settings.decoupleFromSeasonSelection) {
                this.loadReportingData()
            }
        }
    },
    methods: {
        loadReportingData() {
            this.$store.dispatch('loadReportingDataComplete')
             .then(result => {
               setTimeout(() => {
                 this.store = result
               }, 4000)
             })
         }
    },
    // created() {
    //     if (this.$route.params.id) {
    //         this.$store.dispatch('getReport', { _id: this.$route.params.id })
    //     }
    // }
}